import HalfProficiencyIcon from './HalfProficiencyIcon';

export default HalfProficiencyIcon;
export { HalfProficiencyIcon };
